var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2513 26.5217C32.0449 26.3591 31.9166 26.2777 31.8118 26.173C27.0388 21.403 22.2689 16.6269 17.4911 11.8601C16.9782 11.3487 16.7467 10.7763 16.9797 10.0741C17.33 9.02314 18.6187 8.66031 19.4773 9.36094C19.6024 9.4626 19.715 9.57989 19.8292 9.69406C24.9885 14.8534 30.1463 20.0112 35.3041 25.1705C36.233 26.0995 36.2315 26.9393 35.3025 27.8698C30.126 33.0463 24.9479 38.2213 19.7776 43.4041C19.2865 43.8968 18.7344 44.1251 18.0604 43.9312C16.9829 43.6215 16.5762 42.3172 17.2675 41.4336C17.366 41.3069 17.4849 41.1943 17.599 41.0802C22.3439 36.3337 27.0888 31.5872 31.8353 26.8423C31.9307 26.7469 32.0496 26.6734 32.2482 26.5202L32.2513 26.5217Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.44d67aa1c03a8f73e5a15bbfd1a3ec45.svg";
export { ForwardRef as ReactComponent };